import { formatHourTick, istHour, istMidnightUtcMs, istToday, weekdayDateLabel } from "./dateRange";

export function hourlyBuckets(dateStr, sessions = [], now = new Date()) {
  const dayStart = istMidnightUtcMs(dateStr);
  const nowMs = now.getTime();
  const count = dateStr === istToday(now) ? istHour(now) + 1 : 24;
  const buckets = Array.from({ length: count }, (_, hour) => ({
    key: `${dateStr}-${hour}`,
    date: dateStr,
    hour,
    label: formatHourTick(hour),
    activeSeconds: 0,
    autoPauseSeconds: 0,
    manualPauseSeconds: 0,
  }));

  for (const session of sessions) {
    for (const interval of session.intervals || []) {
      const field = secondsField(interval.intervalType);
      if (!field) continue;
      const start = new Date(interval.startTime).getTime();
      const end = interval.endTime ? new Date(interval.endTime).getTime() : nowMs;
      for (const bucket of buckets) {
        const windowStart = dayStart + bucket.hour * 3600000;
        const windowEnd = windowStart + 3600000;
        bucket[field] += overlapSeconds(start, end, windowStart, windowEnd);
      }
    }
  }

  return buckets;
}

export function trendPoints({ from, to, days = [], sessions = [], now = new Date() }) {
  if (from && to && from === to) {
    return hourlyBuckets(from, sessions, now);
  }
  return (days || []).map((day) => ({
    ...day,
    key: day.date,
    label: weekdayDateLabel(day.date),
  }));
}

export function selectTickIndexes(length, maxTicks = 7) {
  if (length <= 0) return [];
  if (length <= maxTicks) {
    return Array.from({ length }, (_, index) => index);
  }
  return Array.from({ length: maxTicks }, (_, index) =>
    Math.round((index * (length - 1)) / (maxTicks - 1)),
  ).filter((value, index, all) => all.indexOf(value) === index);
}

export function niceTimeScale(maxSeconds) {
  const hours = Math.max(0, maxSeconds) / 3600;
  const steps = [
    { max: 0.5, step: 0.1 },
    { max: 1, step: 0.2 },
    { max: 2, step: 0.5 },
    { max: 4, step: 1 },
    { max: 8, step: 2 },
    { max: 12, step: 2 },
    { max: 16, step: 4 },
    { max: 24, step: 4 },
  ];
  const found = steps.find((item) => hours <= item.max) || {
    max: Math.ceil(hours / 4) * 4,
    step: 4,
  };
  const tickHours = [];
  for (let value = 0; value <= found.max + 1e-9; value += found.step) {
    tickHours.push(Math.round(value * 10) / 10);
  }
  return {
    maxSeconds: found.max * 3600,
    tickHours,
  };
}

function secondsField(intervalType) {
  if (intervalType === "ACTIVE") return "activeSeconds";
  if (intervalType === "AUTO_PAUSE") return "autoPauseSeconds";
  if (intervalType === "MANUAL_PAUSE") return "manualPauseSeconds";
  return null;
}

function overlapSeconds(startMs, endMs, windowStart, windowEnd) {
  const from = Math.max(startMs, windowStart);
  const to = Math.min(endMs, windowEnd);
  return Math.max(0, Math.floor((to - from) / 1000));
}
